(function(){
  PegasusTemplate.ColumnOperationsController = Em.ObjectController.extend({
    needs: ['rowOperations', 'viewOptions'],

    zoomValue: function(){
      return this.get('controllers.viewOptions.zoomValue');
    }.property('controllers.viewOptions.zoomValue'),

    activeRow: function(){
      return this.get('controllers.rowOperations.content');
    }.property('controllers.rowOperations.content'),
    clearContentOnRowChange: function(){
      if ( !this.get('activeRow') ) {
        this.set('content', null);
      }

      if ( this.get('content.row') !== this.get('activeRow') ) {
        this.set('content', null);
      }
    }.observes('activeRow.elementId'),
    isMovingSupported: function(){
      var allowed = this.get('allowedColumnOperations') || [];
      return allowed.contains('move');
    }.property('content.allowedColumnOperations'),
    isCopySupported: function(){
      var allowed = this.get('allowedColumnOperations') || [];
      return allowed.contains('copy');
    }.property('content.allowedColumnOperations'),
    isDeleteSupported: function(){
      var allowed = this.get('allowedColumnOperations') || [];
      return allowed.contains('delete');
    }.property('content.allowedColumnOperations'),
    cloneContent: function(){
      var column = this.get('content'),
        row = column.get('row'),
        backup = row.mutateForOut(null, true).editor_cookie,
        element = $(backup),
        cloneTarget = element.find('#'+column.get('elementId')),
        clone = cloneTarget.clone();

      clone.removeAttr('id');
      clone.find('*').removeAttr('id');

      clone.insertAfter(cloneTarget);

      var sourceElement = element[0].outerHTML;

      var command = PegasusTemplate.CloneColumnCommand.create({
        backup: backup,
        klass: column.constructor,
        rowKlass: row.constructor,
        rowPosition: PegasusTemplate.blockRegionInstance.indexOf( row ),
        desiredPosition: row.get('mirrorCapable').indexOf( column ),
        sourceElement: sourceElement
      });

      command.execute();
    },
    deleteContent: function(){
      var column = this.get('content'),
        row = column.get('row');

      var sourceId = column.get('elementId');

      var command = PegasusTemplate.DeleteColumnCommand.create({
        backup: row.mutateForOut(null, true).editor_cookie,
        klass: column.constructor,
        rowKlass: row.constructor,
        rowPosition: PegasusTemplate.blockRegionInstance.indexOf( row ),
        desiredPosition: sourceId
      });

      command.execute();
    },
    moveColumn: function(offset) {
      var column = this.get('content'),
        row = column.get('row'),
        currentPosition = row.get('mirrorCapable').indexOf( column ),
        targetPosition = currentPosition + offset;

      if ( targetPosition === -1 ) {
        targetPosition = row.get('mirrorCapable.length') - 1;
      } else if ( targetPosition === row.get('mirrorCapable.length') ) {
        targetPosition = 0;
      }

      var source = column.get('elementId');
      var target = row.get('mirrorCapable').objectAt( targetPosition ).get('elementId');

      var command = PegasusTemplate.MoveColumnCommand.create({
        backup: row.mutateForOut(null, true).editor_cookie,
        klass: column.constructor,
        rowKlass: row.constructor,
        rowPosition: PegasusTemplate.blockRegionInstance.indexOf( row ),
        currentPosition: source,
        desiredPosition: target
      });

      command.execute();
    },
    moveContentLeft: function() {
      this.moveColumn( -1 );
    },
    moveContentRight: function() {
      this.moveColumn( 1 );
    }
  });
})();
